import gql from 'graphql-tag'

export const INVITE_USER_TO_ORGANIZATION = gql`
  mutation inviteUserToOrganization(
    $organizationSlug: String!
    $inviteData: UserOrganizationInviteData!
  ) {
    inviteUserToOrganization(organizationSlug: $organizationSlug, inviteData: $inviteData)
  }
`

export const INVITE_USER_TO_EVENT = gql`
  mutation inviteUserToEvent(
    $organizationSlug: String!
    $eventId: Int!
    $inviteData: UserEventInviteData!
  ) {
    inviteUserToEvent(
      organizationSlug: $organizationSlug
      eventId: $eventId
      inviteData: $inviteData
    )
  }
`

export const ACCEPT_INVITE = gql`
  mutation acceptInvite($token: String!) {
    acceptInvite(token: $token)
  }
`

export const RESEND_INVITE = gql`
  mutation resendInvite($organizationSlug: String!, $inviteId: Int!) {
    resendInvite(organizationSlug: $organizationSlug, inviteId: $inviteId)
  }
`

export const DELETE_INVITE = gql`
  mutation deleteInvite($organizationSlug: String!, $inviteId: Int!) {
    deleteInvite(organizationSlug: $organizationSlug, inviteId: $inviteId)
  }
`
